import {
  Component,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DeviceService } from 'src/app/services/device.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DeviceComponent {
  protected _deviceService = inject(DeviceService);

  isMobile() {
    return this._deviceService.isMobile();
  }

  isNonMobile() {
    return !this._deviceService.isMobile();
  }
}
